import { apiClient } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

export const getAllListenings = () => apiClient.get(ENDPOINTS.LISTENING.BASE);

export const getListeningById = (id) => apiClient.get(`${ENDPOINTS.LISTENING.BASE}/${id}`);

export const createListening = (listeningData) => apiClient.post(ENDPOINTS.LISTENING.BASE, listeningData);

export const updateListening = (id, listeningData) => apiClient.put(`${ENDPOINTS.LISTENING.BASE}/${id}`, listeningData);

export const deleteListening = (id) => apiClient.delete(`${ENDPOINTS.LISTENING.BASE}/${id}`);
